import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import ApiService from 'global/utils/ApiService';
import { setUserAllowed, userAllowed } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';

export const getIsUserAllowedToMakeOrder = () => async (dispatch: AppDispatch) => {
  await ApiService.get(endpointUrls.userIsAllowedToOrder)
    .then((res: IBackendGetGeneric<userAllowed>) => {
      if (res.isSuccess) dispatch(setUserAllowed(res.data));
    })
    .catch(() => {});
};
